import { render, staticRenderFns } from "./EstimageMessageViewSideMenu.vue?vue&type=template&id=bfb57234"
import script from "./EstimageMessageViewSideMenu.vue?vue&type=script&lang=js"
export * from "./EstimageMessageViewSideMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfb57234')) {
      api.createRecord('bfb57234', component.options)
    } else {
      api.reload('bfb57234', component.options)
    }
    module.hot.accept("./EstimageMessageViewSideMenu.vue?vue&type=template&id=bfb57234", function () {
      api.rerender('bfb57234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/estimagemessage/EstimageMessageViewSideMenu.vue"
export default component.exports